// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609020548/js/" + chunkId + "." + {"44":"4f83cf47","225":"08956318","481":"2670e4fe","486":"0cc920b8","770":"07a13ff3"}[chunkId] + ".0.7573374513570474.chunk.js";
};